import { Components, Theme } from '@mui/material/styles';
import { Box } from '@mui/material';

export const flowFormLabel: Components<Theme>['MuiFormLabel'] = {
  defaultProps: {
    // add a required text for the screen readers
    component: ({ children, className, ...rest }) => (
      <Box component="label" className={className} {...rest}>
        {children}
        {className?.includes('Mui-required') && (
          <Box
            component="span"
            sx={{
              position: 'absolute',
              width: '1px',
              height: '1px',
              margin: '-1px',
              clip: 'rect(0 0 0 0)',
              overflow: 'hidden',
              padding: '0',
              border: 'none',
              whiteSpace: 'nowrap',
            }}
          >{` (required)`}</Box>
        )}
      </Box>
    ),
  },
  styleOverrides: {
    root: ({ theme }) => ({
      // recolor each variant
      '&, &.Mui-disabled, &.Mui-focused, &.Mui-error': {
        transition: 'inherit',
        color: 'inherit',
      },
      [theme.breakpoints.up('xs')]: {
        fontWeight: '400',
      },
      // target just labels for the group of toggles (switch, radio, checkbox)
      '&:not(.MuiInputLabel-root)': {
        // change body1 typography to subheadline
        ...theme.typography.subheadline,
        // space between inputs and label
        paddingBottom: '16px',
        // detect FormMessage
        '& + [role=alert]': {
          // reduce space between Label and message
          marginTop: '-8px',
        },
        // recolor each variant
        '&, &.Mui-disabled, &.Mui-focused': {
          color: theme.palette.text.primary,
        },
      },
    }),
    asterisk: {
      // recolor each variant
      '&, &.Mui-disabled, &.Mui-focused, &.Mui-error': {
        transition: 'inherit',
        color: 'inherit',
      },
    },
  },
};
